/**
 * visitor.js
 * ──────────
 * Reactive snapshot of the signed-in visitor for audience rules on blocks
 * (`block.style.audience`, see Application/websites/cms/blocks/shared/audienceRules.js).
 * Reads window.MediaOS.User, which the Embed bundle defines after it boots,
 * and refreshes on every 'mediaos:authchange'. Until the Embed is ready the
 * visitor counts as signed out, so "signed out" content shows at once and
 * members-only content appears as soon as the identity is known.
 */
import Vue from 'vue';

var visitor = Vue.observable({
	ready: false,
	loggedIn: false,
	membershipTypeIds: [],
	audienceIds: [],
	newsletterIds: []
});

function sync() {
	var U = typeof window !== 'undefined' && window.MediaOS && window.MediaOS.User;
	if (!U) return false;
	try {
		visitor.loggedIn = !!U.IsLoggedIn;
		visitor.membershipTypeIds = (U.MembershipTypeIds || []).slice();
		visitor.audienceIds = (U.AudienceIds || []).slice();
		visitor.newsletterIds = (U.NewsletterIds || []).slice();
		visitor.ready = true;
	} catch (e) { return false; }
	return true;
}

if (typeof window !== 'undefined') {
	var tries = 0;
	(function wait() {
		if (sync()) return;
		if (++tries < 240) setTimeout(wait, 250); // up to a minute: the Embed is deferred
	})();
	window.addEventListener('mediaos:authchange', sync);
}

export default visitor;
export { sync as refreshVisitor };
